// 공지 삭제는 되돌릴 버튼이 화면에 없으므로, 누르기 전에 무엇이 함께 사라지는지 보여준다(VMD-420).
// 2026-11-02 에 매장 10곳이 올린 이행 사진 50건이 공지와 함께 지워졌고, 삭제한 사람은 그 사실을
// 확인 문구에서 알 수 없었다. executeCount 는 임직원 계정에만 내려오므로 없을 때는 기존 문구를 그대로 쓴다.
// total 과 n 은 서버가 문자열로 내려준다. n 은 '이행 전' 수이므로 올라온 건수는 total 에서 n 을 뺀 값이다.

export const NOTICE_DELETE_CONFIRM_BASE = "해당 공지를 삭제하시겠습니까?";

type ExecuteCountLike = { total?: string | number | null; n?: string | number | null } | null | undefined;

export const buildNoticeDeleteConfirmMessage = (executeCount: ExecuteCountLike): string => {
  if (executeCount == null) return NOTICE_DELETE_CONFIRM_BASE;

  const total = Number(executeCount.total);
  const notYet = Number(executeCount.n);
  if (!Number.isFinite(total) || !Number.isFinite(notYet) || total <= 0) return NOTICE_DELETE_CONFIRM_BASE;

  const done = total - notYet;
  if (done <= 0) return `${NOTICE_DELETE_CONFIRM_BASE}\n\n이행 대상 ${total}곳 중 올라온 이행 사진은 없습니다.`;

  return (
    `${NOTICE_DELETE_CONFIRM_BASE}\n\n이행 대상 ${total}곳 중 ${done}곳이 이행 사진을 올린 상태입니다.\n` +
    "삭제하면 올라온 사진과 평가도 함께 사라집니다."
  );
};
